// import { db } from "../../firestore-config";
// import { collection,getDocs,getDoc,addDoc,updateDoc,deleteDoc,doc, query, where} from "firebase/firestore";
// import { firestore } from "firebase-admin";
// import { User } from "../models/user";
// import { Category } from "../models/category";
// import { Product } from "../models/product";

// const categoryCollectionRef = collection(db,"categories");
// const productCollectionRef = collection(db,"Products");
// const newarrivalProductsCollectionRef = collection(db,"newarrivalproducts");
// const productsCollectionsRef = collection(db,"productscollections");
// const userCollectionRef = collection(db,"User");
// const userService = {
//     register: (user:User) =>{
//         return addDoc(userCollectionRef,user)
//     },
//     manage: (id:any,user:User) =>{
//     const userinfo = doc(userCollectionRef,"User",id);
//     updateDoc(userinfo,{
//         user 
//     });
//     return getDoc(userinfo);
//     },
//     delete: (id:any)=>{
//         const userinfo = doc(userCollectionRef,"User",id);
//         deleteDoc(userinfo);
//     },
//     users:()=>{
//         return getDocs(userCollectionRef);
//     }
// }
// const categoryService = {
//     register: (category:Category) =>{
//         return addDoc(categoryCollectionRef,category)
//     },
//     manage: (id:any,category:Category) =>{
//     const categoryinfo = doc(categoryCollectionRef,"Categories",id);
//     updateDoc(categoryinfo,{
//         category 
//     });
//     return getDoc(categoryinfo);
//     },
//     delete: (id:any)=>{
//         const categoryinfo = doc(categoryCollectionRef,"Categories",id);
//         deleteDoc(categoryinfo);
//     },
//     categories:()=>{
//         return getDocs(categoryCollectionRef);
//     },
//     parentCategories:() =>{
//         return  getDocs(query(categoryCollectionRef,where("parentCategory", "==","")))
//     }
// }
// const productService = {
//     register: (product:Product) =>{
//         return addDoc(productCollectionRef,product)
//     },
//     manage: (id:any,product:Product) =>{
//     const productinfo = doc(productCollectionRef,"Products",id);
//     updateDoc(productinfo,{
//         product 
//     });
//     return getDoc(productinfo);
//     },
//     delete: (id:any)=>{
//         const productinfo = doc(productCollectionRef,"Products",id);
//         deleteDoc(productinfo);
//     },
//     products:()=>{
//         return getDocs(productCollectionRef);
//     }
// }
// const ourProductsCollectionsService = {
//     register: (product:Product) =>{
//         return addDoc(productsCollectionsRef,product)
//     },
//     manage: (id:any,product:Product) =>{
//     const productinfo = doc(productsCollectionsRef,"productscollections",id);
//     updateDoc(productinfo,{
//         product 
//     });
//     return getDoc(productinfo);
//     },
//     delete: (id:any)=>{
//         const productinfo = doc(productsCollectionsRef,"productscollections",id);
//         deleteDoc(productinfo);
//     },
//     products:()=>{
//         return getDocs(productsCollectionsRef);
//     }
// }
// const newarrivalProductsCollectionsService = {
//     register: (product:Product) =>{
//         return addDoc(newarrivalProductsCollectionRef,product)
//     },
//     manage: (id:any,product:Product) =>{
//     const productinfo = doc(newarrivalProductsCollectionRef,"newarrivalproducts",id);
//     updateDoc(productinfo,{
//         product 
//     });
//     return getDoc(productinfo);
//     },
//     delete: (id:any)=>{
//         const productinfo = doc(newarrivalProductsCollectionRef,"newarrivalproducts",id);
//         deleteDoc(productinfo);
//     },
//     products:()=>{
//         return getDocs(newarrivalProductsCollectionRef);
//     }
// }
// const firebaseAgent = {    
//     userService,        
//     categoryService,
//     productService,
//     ourProductsCollectionsService,
//     newarrivalProductsCollectionsService
// }
// export default firebaseAgent;

// import { db } from "../../firestore-config";
// import { 
//     collection, 
//     getDocs, 
//     getDoc, 
//     addDoc, 
//     updateDoc, 
//     deleteDoc, 
//     doc, 
//     query, 
//     where, 
//     CollectionReference, 
//     DocumentData,
//     WithFieldValue,
//     UpdateData
// } from "firebase/firestore";
// import { User } from "../models/user";
// import { Category } from "../models/category";
// import { Product } from "../models/product";

// /**
//  * A Generic Base Service to handle standard CRUD operations
//  */
// class BaseService<T extends DocumentData> {
//     protected collectionRef: CollectionReference<T>;

//     constructor(collectionName: string) {
//         this.collectionRef = collection(db, collectionName) as CollectionReference<T>;
//     }

//     // Create
//     register(data: WithFieldValue<T>) {
//         return addDoc(this.collectionRef, data);
//     }

//     // Update & Return updated doc
//     async manage(id: string, data: UpdateData<T>) {
//         const docRef = doc(this.collectionRef, id);
//         await updateDoc(docRef, data);
//         return getDoc(docRef);
//     }

//     // Delete
//     delete(id: string) {
//         const docRef = doc(this.collectionRef, id);
//         return deleteDoc(docRef);
//     }

//     // Get All
//    async getAll() {
//         return getDocs(this.collectionRef);
//     }
// }

// /**
//  * Specialized Services
//  * We can extend the BaseService to add specific queries like "parentCategories"
//  */
// class CategoryService extends BaseService<Category> {
//     constructor() {
//         super("categories");
//     }
//     getParentCategories() {
//         const q = query(this.collectionRef, where("parentCategory", "==", ""));
//         return getDocs(q);
//     }    
// }

// class ParentCategoryService extends BaseService<Category> {
//     constructor() {
//         super("categories");
//     }

//     getParentCategories() {
//         const q = query(this.collectionRef, where("parentCategory", "==", ""));
//         return getDocs(q);
//     }
//     // Inside your Service class (e.g., CategoryService)
//     getByParent(parentId: string) {
//         const q = query(
//             this.collectionRef, 
//             where("parentId", "==", (parentId !== null && parentId !== undefined) ? parentId : null)
//         );
//         return getDocs(q);
//     }
// }

// // Initialize Services
// const userService = new BaseService<User>("User");
// const categoryService = new CategoryService();
// const parentCategoryService = new ParentCategoryService();
// const productService = new BaseService<Product>("products");
// const ourProductsCollectionsService = new BaseService<Product>("productscollections");
// const newarrivalProductsCollectionsService = new BaseService<Product>("newarrivalproducts");

// const firebaseAgent = {
//     userService: {
//         register: (u: User) => userService.register(u),
//         manage: (id: string, u: User) => userService.manage(id, u),
//         delete: (id: string) => userService.delete(id),
//         users: () => userService.getAll(),
//     },
//     categoryService: {
//         register: (c: Category) => categoryService.register(c),
//         manage: (id: string, c: Category) => categoryService.manage(id, c),
//         delete: (id: string) => categoryService.delete(id),
//         // categories: () => categoryService.getAll(),
//         // parentCategories: () => categoryService.getParentCategories(),
//         getAll: () => categoryService.getAll(),
//     },
//     parentCategoryService: {
//         register: (c: Category) => parentCategoryService.register(c),
//         manage: (id: string, c: Category) => parentCategoryService.manage(id, c),
//         delete: (id: string) => parentCategoryService.delete(id),
//         getAll: (parentId:string) => parentCategoryService.getAll(),
//         getByParent: (parentId:string) => parentCategoryService.getByParent(parentId),
//     },
//     productService: {
//         register: (p: Product) => productService.register(p),
//         manage: (id: string, p: Product) => productService.manage(id, p),
//         delete: (id: string) => productService.delete(id),
//         // products: () => productService.getAll(),
//         getAll: () => productService.getAll()
//     },
//     ourProductsCollectionsService: {
//         register: (p: Product) => ourProductsCollectionsService.register(p),
//         manage: (id: string, p: Product) => ourProductsCollectionsService.manage(id, p),
//         delete: (id: string) => ourProductsCollectionsService.delete(id),
//         //products: () => ourProductsCollectionsService.getAll(),
//         getAll: () => ourProductsCollectionsService.getAll(),
//     },
//     newarrivalProductsCollectionsService: {
//         register: (p: Product) => newarrivalProductsCollectionsService.register(p),
//         manage: (id: string, p: Product) => newarrivalProductsCollectionsService.manage(id, p),
//         delete: (id: string) => newarrivalProductsCollectionsService.delete(id),
//         //products: () => newarrivalProductsCollectionsService.getAll(),
//         getAll: () => newarrivalProductsCollectionsService.getAll()
//     }
// };

// export default firebaseAgent;

import { db } from "../../firestore-config";
import { 
    collection, 
    getDocs, 
    getDoc, 
    addDoc, 
    updateDoc, 
    deleteDoc, 
    doc, 
    query, 
    where, 
    CollectionReference, 
    DocumentData,
    WithFieldValue,
    UpdateData,
    limit
} from "firebase/firestore";
import { User } from "../models/user";
import { Category } from "../models/category";
import { Product } from "../models/product";
import { CartItem } from "../models/cartItem";
import { Booking } from "../models/booking";
import { WishlistItem } from "../models/wishlistItem";
import { Coupon } from "../models/coupon";

/**
 * Enhanced Generic Base Service
 */
class BaseService<T extends DocumentData> {
    protected collectionRef: CollectionReference<T>;

    constructor(collectionName: string) {
        this.collectionRef = collection(db, collectionName) as CollectionReference<T>;
    }

    register(data: WithFieldValue<T>) {
        return addDoc(this.collectionRef, data);
    }

    async manage(id: string, data: UpdateData<T>) {
        const docRef = doc(this.collectionRef, id);
        await updateDoc(docRef, data);
        return getDoc(docRef);
    }

    /**
     * PARTIAL UPDATE (Enhanced for InventoryManager)
     * Optimized for quick updates like stock or price without 
     * fetching the document back.
     */
    async update(id: string, data: UpdateData<T>) {
        const docRef = doc(this.collectionRef, id);
        return await updateDoc(docRef, data);
    }

    delete(id: string) {
        return deleteDoc(doc(this.collectionRef, id));
    }

    async getAll() {
        return getDocs(this.collectionRef);
    }

    /**
     * GENERIC IMPLEMENTATION: Load entries by parent reference.
     * Supports both "parentId" and "parentCategory" fields commonly used in your stores.
     */
    getByParent(parentId: string | null, fieldName: string = "parentId") {
        const q = query(
            this.collectionRef, 
            where(fieldName, "==", parentId ?? "")
        );
        return getDocs(q);
    }
}


/**
 * Specialized Category Service
 */
// class CategoryService extends BaseService<Category> {
//     constructor() {
//         super("categories");
//     }

//     // // Returns top-level categories (where parent is empty string or null)
//     // getParentCategories() {
//     //     return this.getByParent(""); 
//     // }
// }

// Initialize Services
const userService = new BaseService<User>("User");
const categoryService = new BaseService<Category>("categories"); //new CategoryService();
const productService = new BaseService<Product>("products");
const ourProductsCollectionsService = new BaseService<Product>("productscollections");
const newarrivalProductsCollectionsService = new BaseService<Product>("newarrivalproducts");
const cartService = new BaseService<CartItem>("carts");
const bookingService = new BaseService<Booking>("bookings");
const wishlistService = new BaseService<WishlistItem>("wishlist");
const couponService = new BaseService<Coupon>("coupons");

const firebaseAgent = {
    userService: {
        register: (u: User) => userService.register(u),
        manage: (id: string, u: User) => userService.manage(id, u),
        delete: (id: string) => userService.delete(id),
        users: () => userService.getAll(),
    },
    categoryService: {
        register: (c: Category) => categoryService.register(c),
        manage: (id: string, c: Category) => categoryService.manage(id, c),
        delete: (id: string) => categoryService.delete(id),
        getAll: () => categoryService.getAll(),
        //getParentCategories: () => categoryService.getParentCategories(),
        // Access generic parent loader
        getByParent: (parentId: string) => categoryService.getByParent(parentId)
    },
    productService: {
        register: (p: Product) => productService.register(p),
        manage: (id: string, p: Product) => productService.manage(id, p),
        delete: (id: string) => productService.delete(id),
        getAll: () => productService.getAll(),
        // Update (Partial - critical for the Inventory Manager)
        // This allows calling: update(id, { stock: 10 })
        update: (id: string, p: Partial<Product>) => productService.update(id, p),
        // Generic parent loader (useful if products belong to category IDs)
        getByParent: (categoryId: string) => productService.getByParent(categoryId, "categoryId")
    },
    ourProductsCollectionsService: {
        register: (p: Product) => ourProductsCollectionsService.register(p),
        manage: (id: string, p: Product) => ourProductsCollectionsService.manage(id, p),
        delete: (id: string) => ourProductsCollectionsService.delete(id),
        getAll: () => ourProductsCollectionsService.getAll(),
    },
    newarrivalProductsCollectionsService: {
        register: (p: Product) => newarrivalProductsCollectionsService.register(p),
        manage: (id: string, p: Product) => newarrivalProductsCollectionsService.manage(id, p),
        delete: (id: string) => newarrivalProductsCollectionsService.delete(id),
        getAll: () => newarrivalProductsCollectionsService.getAll()
    },
    cartItemService: {
        /**
         * Standard CRUD for cart items
         */
        register: (c: CartItem) => cartService.register(c),
        manage: (id: string, c: Partial<CartItem>) => cartService.manage(id, c),
        delete: (id: string) => cartService.delete(id),        
        /**
         * Load all items in the database (admin view)
         */
        getAll: () => cartService.getAll(),
        /**
         * Load items for a specific user.
         * Uses the generic getByParent with "userId" as the default field.
         */
        getByUser: (userId: string) => cartService.getByParent(userId, "userId"),
    },
    bookingService: {
        register: (b: Booking) => bookingService.register(b),
        manage: (id: string, b: UpdateData<Booking>) => bookingService.manage(id, b),
        delete: (id: string) => bookingService.delete(id),
        getByParent: (parentId: string) => bookingService.getByParent(parentId, "userId"),
        // Allows user to see their order history
        getByUser: (userId: string) => bookingService.getByParent(userId, "userId"),
        getAll: () => bookingService.getAll(), 
    },
    wishlistService: {
        register: (w: WishlistItem) => wishlistService.register(w),
        manage: (id: string, w: Partial<WishlistItem>) => wishlistService.manage(id, w),
        delete: (id: string) => wishlistService.delete(id),
        // Use generic getByParent to isolate by user
        getByUser: (userId: string) => wishlistService.getByParent(userId, "userId"),
    },
    couponService: {
        register: (c: Coupon) => couponService.register(c),
        manage: (id: string, c: Coupon) => couponService.manage(id, c),
        delete: (id: string) => couponService.delete(id),
        getAll: () => couponService.getAll(),
        findByCode: (code: string) => couponService.getByParent(code, "code")
    },
    
};

export default firebaseAgent;